// extracted by mini-css-extract-plugin
module.exports = {"top":"title_top__1aWQF","topText":"title_topText__ro9Cz"};